<template>
  <button
    v-if="visible(item)"
    :disabled="working(item) || item.changingVersion"
    :class="{
      'is-loading': working(item)
    }"
    class="button is-small smaller darker is-success"
    @click="$emit('click')"
  >
    Install
  </button>
</template>

<script>
import packageStatuses from "@/utils/packageStatus";

export default {
  props: { item: Object },
  computed: {
    working() {
      return item => item.command && item.command.status === "working";
    },
    visible() {
      return item => {
        const working = packageStatuses.isWorking(item);
        const uninstallable = packageStatuses.isUninstallable(item);
        const installable = packageStatuses.isInstallable(item);

        return (
          (installable && !uninstallable && !working) ||
          (uninstallable && working)
        );
      };
    }
  }
};
</script>
